import { groupBy } from "lodash";
import moment from "moment";
import { IAggregatPeriod } from "./aggregatperiod";

export class BufferedArraySegment<T> {
    private readonly segmentBuffer: any = {};

    constructor(private readonly raw: T[], private readonly dateGetter: (instance: T) => Date) {
    }

    get all(): T[] {
        return this.raw;
    }

    periodSegment = (period: IAggregatPeriod): T[] => this.dateFormatSegment(period.format, period.key);

    private readonly dateFormatSegment = (formatstr: string, key: string): T[] => {

        let result = this.segmentBuffer[formatstr];
        if (result != null) {
            return result[key] || [];
        }

        const iteratee = (item: T): string => moment(this.dateGetter(item)).format(formatstr);
        result = groupBy(this.raw, iteratee);

        this.segmentBuffer[formatstr] = result;
        return result[key] || [];
    };
}
